import _ from 'lodash'
import ConfigAnalyze from '@/utils/ConfigAnalyze'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Vue from 'vue'

const state = {
  // ConfigAnalyze: ConfigAnalyze,

  isInit: false,
  loading: false,
  // isSubmit: false, // 各modeで決定をして商品数が一つでも入ったかどうか
  submit: {
    base: false,
    target: false,
    together: []
  },

  //  商品初期データ
  constData: {
    product_area: [],
    product_group: [],
    productCategoryLevel: 1,
    target_product_categories: [],
    product_category: [],
    category_group: [],
    product_attribute_l: [],
    product_attribute_s: []
  },
  //  初期商品分析パラメータ
  condition: {
  },
  //  商品カート設定
  cartSettings: [
    {},
    // cartSeetings[1] (商品コード)
    {
      labelName: 'item_name',
      keyName: 'item_code'
    },
    // cartSeetings[2] (janコード)
    {
      labelName: 'jannm',
      keyName: 'jancd'
    }
  ]
}

const actions = {
  setConstData ({ commit }, payload) {
    commit('setConstData', payload)
  },
  setCondition ({ commit }, payload) {
    commit('setIsSubmit', false)
    commit('setCondition', payload)
  },
  setHistoryCondition ({ state, commit, dispatch }, payload) {
    commit('setIsSubmit', false)
    payload.item_base_code.length = 0
    payload.item_target_code.length = 0
    for (let i = 0; i < payload.item_together.conditions.length; i++) {
      payload.item_together.conditions[i].code.length = 0
    }
    commit('setCondition', payload)

    let paramBase = {
      panelName: 'base',
      togetherIndex: 0,
      data: null,
      codeExclude: true
    }
    dispatch('setHistoryConditionPanel', paramBase)

    let paramTarget = {
      panelName: 'target',
      togetherIndex: 0,
      data: null,
      codeExclude: true
    }
    dispatch('setHistoryConditionPanel', paramTarget)

    for (let i = 0; i < payload.item_together.conditions.length; i++) {
      let paramTogether = {
        panelName: 'together',
        togetherIndex: i,
        data: null,
        codeExclude: true
      }
      dispatch('setHistoryConditionPanel', paramTogether)
    }
  },
  setHistoryConditionPanel ({ state, commit, dispatch }, param) {
    let panel = param.panelName

    let analyze = {}
    if (panel === 'together') {
      analyze = state.condition.item_together.conditions[param.togetherIndex].analyze
    } else {
      analyze = state.condition['item_' + panel].analyze
    }

    let mode = analyze.mode
    if (mode === 'code') {
      if (analyze.code.length > 0) {
        param.data = analyze.code
        dispatch('submitCode', param)
      }
    } else if (mode === 'name') {
      if (analyze.name.length > 0) {
        param.data = analyze.name
        dispatch('submitName', param)
      }
    } else if (mode === 'file') {
      const paramFile = {
        panelName: panel,
        togetherIndex: 0,
        fileName: analyze.file_name
      }
      commit('setFileName', paramFile)
    } else if (mode === 'group') {
      if (analyze.group.length > 0) {
        param.data = analyze.group
        dispatch('submitGroup', param)
      }
    } else if (mode === 'category') {
      if (analyze.category.code.length > 0) {
        param.data = _.cloneDeep(analyze.category)
        param.data.area = analyze.product_area_code
        dispatch('submitCategory', param)
      }
    } else if (mode === 'category_group') {
      if (analyze.category_group.id.length > 0) {
        param.data = _.cloneDeep(analyze.category_group)
        param.data.area = analyze.product_area_code
        dispatch('submitCategoryGroup', param)
      }
    } else if (mode === 'product_attribute') {
      if (analyze.product_attribute.code.length > 0) {
        param.data = _.cloneDeep(analyze.product_attribute)
        dispatch('submitAttribute', param)
      }
    } else if (mode === 'freeword') {
      param.freeword = analyze.freeword
      if (analyze.freeword_code.length > 0) {
        param.data = analyze.freeword_code
        dispatch('submitFreeword', param)
      }
    }
  },
  /**
   * 利用コードを変更したらリセット
   */
  submitCodePattern ({ state, commit }, payload) {
    //  初期化
    let initData = _.cloneDeep(ConfigAnalyze.analyze.condition.product)

    //  リセットしないもの
    initData.code_pattern = payload
    initData.contract_flag = state.condition.contract_flag

    initData.item_base.analyze.is_all = state.condition.item_base.analyze.is_all
    initData.item_base.analyze.mode = 'category'
    initData.item_base.analyze.freeword = state.condition.item_base.analyze.freeword

    initData.item_target.analyze.is_all = state.condition.item_target.analyze.is_all
    initData.item_target.analyze.mode = state.condition.item_target.analyze.mode
    initData.item_target.analyze.freeword = state.condition.item_target.analyze.freeword

    if (initData.code_pattern === 1) {
      if (state.constData.product_area && state.constData.product_area.length > 0) {
        initData.item_base.analyze.product_area_code = state.constData.product_area[0].code
        initData.item_target.analyze.product_area_code = state.constData.product_area[0].code
      } else {
        initData.item_base.analyze.product_area_code = null
        initData.item_target.analyze.product_area_code = null
      }
    }
    commit('setIsSubmit', false)
    commit('setCondition', initData)
  },
  setIsAll ({ commit }, payload) {
    const data = {
      panelName: payload.panelName,
      togetherIndex: payload.togetherIndex,
      data: payload.data
    }
    commit('setIsAll', data)
  },
  /**
   * 商品コード決定からカートに商品を追加
   * @param [商品コードString] payload
   */
  async submitCode ({ state, commit }, payload) {
    commit('setLoading', true)
    let contractFlag = state.condition.contract_flag
    if (payload.panelName === 'target' && Constants.getSite('target_product_all_flag') === '1') {
      // 比較商品から商品を検索した場合、contract_flag=3で検索を行う
      contractFlag = 3
    }
    let res
    if (state.condition.code_pattern === 1) {
      const param = {
        code: payload.data,
        analyze_target_code: this.getters['condition/getType'],
        contract_flag: contractFlag
      }
      //  商品コード利用
      res = await ApiManager.request('ItemSearch').itemSearchCode(param)
    } else {
      const param = {
        code: payload.data,
        analyze_target_code: this.getters['condition/getType'],
        contract_flag: contractFlag
      }
      //  JANコード利用
      res = await ApiManager.request('ProductSearch').productSearchCode(param)
    }

    if (res.data.data.length > 0) {
      const data = {
        panelName: payload.panelName,
        togetherIndex: payload.togetherIndex,
        data: res.data.data,
        isSubmit: true
      }
      if (payload.codeExclude) {
        data.codeExclude = true
      }

      commit('setIsSubmit', data)
      commit('setCartItem', data)
      commit('setCode', payload)
    }
    commit('setLoading', false)
  },
  /**
   * 商品名決定からカートに商品を追加
   * @param { String } payload 商品名
   */
  async submitName ({ state, commit }, payload) {
    commit('setLoading', true)
    let contractFlag = state.condition.contract_flag
    if (payload.panelName === 'target' && Constants.getSite('target_product_all_flag') === '1') {
      // 比較商品から商品を検索した場合、contract_flag=3で検索を行う
      contractFlag = 3
    }
    let res
    if (state.condition.code_pattern === 2) {
      const param = {
        name: payload.data,
        analyze_target_code: this.getters['condition/getType'],
        contract_flag: contractFlag
      }
      res = await ApiManager.request('ProductSearch').productSearchName(param)

      if (res.data.data.length > 0) {
        const data = {
          panelName: payload.panelName,
          togetherIndex: payload.togetherIndex,
          data: res.data.data,
          isSubmit: true
        }
        if (payload.codeExclude) {
          data.codeExclude = true
        }

        commit('setIsSubmit', data)
        commit('setCartItem', data)
        commit('setName', payload)
      }
    }
    commit('setLoading', false)
  },
  /**
   * カテゴリーリストからカートに商品を追加
   * @param { Object } payload パネルモード、商品コード
   */
  async submitFile ({ state, commit }, payload) {
    commit('setLoading', true)
    let contractFlag = state.condition.contract_flag
    if (payload.panelName === 'target' && Constants.getSite('target_product_all_flag') === '1') {
      // 比較商品から商品を検索した場合、contract_flag=3で検索を行う
      contractFlag = 3
    }
    let res
    if (state.condition.code_pattern === 1) {
      //  商品コード利用
      res = await ApiManager.request('ItemSearch').itemSearchFile(payload.file,
        this.getters['condition/getType'], contractFlag)
    } else {
      //  JANコード利用
      res = await ApiManager.request('ProductSearch').productSearchFile(payload.file,
        this.getters['condition/getType'], contractFlag)
    }

    if (res.data.data.length > 0) {
      const data = {
        panelName: payload.panelName,
        togetherIndex: payload.togetherIndex,
        data: res.data.data,
        isSubmit: true
      }
      if (payload.codeExclude) {
        data.codeExclude = true
      }

      commit('setIsSubmit', data)
      commit('setCartItem', data)
      commit('setFileName', payload)
    } else {
      this.dispatch('routerdata/setApiMessage', res.data.data.message)
    }
    commit('setLoading', false)
  },
  //  商品グループ決定
  async submitGroup ({ commit }, payload) {
    commit('setLoading', true)
    let contractFlag = state.condition.contract_flag
    if (payload.panelName === 'target' && Constants.getSite('target_product_all_flag') === '1') {
      // 比較商品から商品を検索した場合、contract_flag=3で検索を行う
      contractFlag = 3
    }
    let res
    if (state.condition.code_pattern === 1) {
      const param = {
        id: payload.data,
        analyze_target_code: this.getters['condition/getType'],
        contract_flag: contractFlag
      }
      //  商品コード利用
      res = await ApiManager.request('ItemSearch').itemSearchGroup(param)
    } else {
      const param = {
        id: payload.data,
        analyze_target_code: this.getters['condition/getType'],
        contract_flag: contractFlag
      }
      //  JANコード利用
      res = await ApiManager.request('ProductSearch').productSearchGroup(param)
    }

    if (res.data.data.length > 0) {
      const data = {
        panelName: payload.panelName,
        togetherIndex: payload.togetherIndex,
        data: res.data.data,
        isSubmit: true
      }
      if (payload.codeExclude) {
        data.codeExclude = true
      }
      commit('setIsSubmit', data)
      commit('setCartItem', data)
      commit('setGroup', payload)
    }

    commit('setLoading', false)
  },
  /**
   * カテゴリーリストからカートに商品を追加
   */
  async submitCategory ({ state, commit }, payload) {
    const data = {
      panelName: payload.panelName,
      togetherIndex: payload.togetherIndex,
      isSubmit: true
    }

    commit('setIsSubmit', data)
    commit('setCartItemNoList', data)
    commit('setCategory', payload)
  },
  //  商品カテゴリグループ決定
  async submitCategoryGroup ({ state, commit }, payload) {
    const data = {
      panelName: payload.panelName,
      togetherIndex: payload.togetherIndex,
      isSubmit: true
    }

    commit('setIsSubmit', data)
    commit('setCartItemNoList', data)
    commit('setCategoryGroup', payload)
  },
  /**
   * 商品属性決定からカートに商品を追加
   */
  async submitAttribute ({ state, commit }, payload) {
    const data = {
      panelName: payload.panelName,
      togetherIndex: payload.togetherIndex,
      isSubmit: true
    }

    commit('setIsSubmit', data)
    commit('setCartItemNoList', data)
    commit('setAttribute', payload)
  },
  //  フリーワード検索決定
  async submitFreeword ({ state, commit }, payload) {
    commit('setLoading', true)
    let contractFlag = state.condition.contract_flag
    if (payload.panelName === 'target' && Constants.getSite('target_product_all_flag') === '1') {
      // 比較商品から商品を検索した場合、contract_flag=3で検索を行う
      contractFlag = 3
    }
    let res
    if (state.condition.code_pattern === 1) {
      const param = {
        code: payload.data,
        analyze_target_code: this.getters['condition/getType'],
        contract_flag: contractFlag
      }
      //  商品コード利用
      res = await ApiManager.request('ItemSearch').itemSearchCode(param)
    } else {
      const param = {
        code: payload.data,
        analyze_target_code: this.getters['condition/getType'],
        contract_flag: contractFlag
      }
      //  JANコード利用
      res = await ApiManager.request('ProductSearch').productSearchCode(param)
    }

    if (res.data.data.length > 0) {
      const data = {
        panelName: payload.panelName,
        togetherIndex: payload.togetherIndex,
        data: res.data.data,
        isSubmit: true
      }
      if (payload.codeExclude) {
        data.codeExclude = true
      }

      commit('setIsSubmit', data)
      commit('setCartItem', data)
      commit('setFreeword', payload)
    }
    commit('setLoading', false)
  },
  addTogether ({ state, commit }) {
    let together = {
      code: [],
      analyze: {}
    }
    together.analyze = _.cloneDeep(ConfigAnalyze.analyze.condition.product.item_base.analyze)

    commit('addTogether', together)
  },
  decideGroupMode ({ state, commit }, payload) {
    const mode = payload.mode
    const division = Constants.getContract('division')
    if (division === 1 || division === 2) {
      // division=1,2の場合、追加、編集ボタンを押すと、GR00004 or GR00007へ遷移
      Vue.localStorage.set('groupMode', mode === 'product' ? 'GR00004' : 'GR00007')
    } else {
      let currentAnalyzeTarget = Constants.getAnalyzeTarget(this.getters['condition/getType'])
      if (currentAnalyzeTarget) {
        if (currentAnalyzeTarget.pos_flag === 1) {
          // 追加、編集ボタンを押すと、GR00009 or GR00011へ遷移
          Vue.localStorage.set('groupMode', mode === 'product' ? 'GR00009' : 'GR00011')
        } else if (currentAnalyzeTarget.pos_flag === 2) {
          // 追加、編集ボタンを押すと、GR00010 or GR00012へ遷移
          Vue.localStorage.set('groupMode', mode === 'product' ? 'GR00010' : 'GR00012')
        }
      }
    }
  }
}

const mutations = {
  setIsInit (state, data) {
    state.isInit = data
  },
  setLoading (state, data) {
    state.loading = data
    if (data) {
      this.dispatch('loading/loadingPagePlus')
    } else {
      this.dispatch('loading/loadingPageMinus')
    }
  },
  setConstData (state, data) {
    Object.keys(state.constData).forEach(
      key => {
        if (key in data) {
          state.constData[key] = data[key]
        } else {
          state.constData[key] = []
        }
      }
    )

    //  カテゴリ階層算出
    let maxrank = 1
    const cat = state.constData.product_category
    for (let i = 0; i < cat.length; i++) {
      if (cat[i].rank > maxrank) {
        maxrank = cat[i].rank
      }
    }
    maxrank = maxrank - 0
    let siteMaxrank = Constants.getSite('product_category_rank_qty')
    siteMaxrank = siteMaxrank - 0
    if (maxrank > siteMaxrank) {
      maxrank = siteMaxrank
    }
    state.constData.productCategoryLevel = maxrank
  },
  setCondition (state, data) {
    state.condition = data
  },
  setCodePattern (state, data) {
    state.condition.code_pattern = data
  },
  setContractFlag (state, data) {
    state.condition.contract_flag = data
  },
  setHasTarget (state, data) {
    state.condition.has_target = data
  },
  setIsSubmit (state, data) {
    if (data === false) {
      state.submit.base = false
      state.submit.target = false
      for (let i = 0; i < state.submit.together.length; i++) {
        state.submit.together[i] = false
      }
      state.submit.together.splice()
    } else {
      if (data.panelName === 'together') {
        state.submit.together[data.togetherIndex] = data.isSubmit
        state.submit.together.splice()
      } else {
        state.submit[data.panelName] = data.isSubmit
      }
    }
  },
  setIsAll (state, data) {
    if (data.panelName === 'together') {
      state.condition.item_together.conditions[data.togetherIndex].analyze.is_all = data.data
    } else {
      state.condition['item_' + data.panelName].analyze.is_all = data.data
      if (data.panelName === 'target') {
        if (data.data) {
          state.condition.has_target = 1
        } else {
          state.condition.has_target = 0
        }
      }
    }
  },
  setMode (state, data) {
    if (data.panelName === 'together') {
      state.condition.item_together.conditions[data.togetherIndex].analyze.mode = data.mode
    } else {
      state.condition['item_' + data.panelName].analyze.mode = data.mode
    }
  },
  setCode (state, data) {
    if (data.panelName === 'together') {
      state.condition.item_together.conditions[data.togetherIndex].analyze.code = data.data
      state.condition.item_together.conditions[data.togetherIndex].analyze.mode = 'code'
    } else {
      state.condition['item_' + data.panelName].analyze.code = data.data
      state.condition['item_' + data.panelName].analyze.mode = 'code'
    }
  },
  setName (state, data) {
    if (data.panelName === 'together') {
      state.condition.item_together.conditions[data.togetherIndex].analyze.name = data.data
      state.condition.item_together.conditions[data.togetherIndex].analyze.mode = 'name'
    } else {
      state.condition['item_' + data.panelName].analyze.name = data.data
      state.condition['item_' + data.panelName].analyze.mode = 'name'
    }
  },
  setFileName (state, data) {
    if (data.panelName === 'together') {
      state.condition.item_together.conditions[data.togetherIndex].analyze.file_name = data.fileName
      state.condition.item_together.conditions[data.togetherIndex].analyze.mode = 'file'
    } else {
      state.condition['item_' + data.panelName].analyze.file_name = data.fileName
      state.condition['item_' + data.panelName].analyze.mode = 'file'
    }
  },
  setGroup (state, data) {
    if (data.panelName === 'together') {
      state.condition.item_together.conditions[data.togetherIndex].analyze.group = data.data
      state.condition.item_together.conditions[data.togetherIndex].analyze.mode = 'group'
    } else {
      state.condition['item_' + data.panelName].analyze.group = data.data
      state.condition['item_' + data.panelName].analyze.mode = 'group'
    }
  },
  setCategory (state, data) {
    let ana
    if (data.panelName === 'together') {
      ana = state.condition.item_together.conditions[data.togetherIndex].analyze
    } else {
      ana = state.condition['item_' + data.panelName].analyze
    }
    ana.category.code = data.data.code
    ana.product_area_code = data.data.area
    ana.category.noSubmit = false
    ana.mode = 'category'
  },
  setCategoryGroup (state, data) {
    let ana
    if (data.panelName === 'together') {
      ana = state.condition.item_together.conditions[data.togetherIndex].analyze
    } else {
      ana = state.condition['item_' + data.panelName].analyze
    }
    ana.category_group.id = data.data.id
    ana.product_area_code = data.data.area
    ana.category_group.noSubmit = false
    ana.mode = 'category_group'
  },
  setAttribute (state, data) {
    let ana
    if (data.panelName === 'together') {
      ana = state.condition.item_together.conditions[data.togetherIndex].analyze
    } else {
      ana = state.condition['item_' + data.panelName].analyze
    }
    ana.product_attribute.code = data.data.code
    ana.product_attribute.noSubmit = false
    ana.mode = 'product_attribute'
  },
  setFreeword (state, data) {
    let ana = {}
    if (data.panelName === 'together') {
      ana = state.condition.item_together.conditions[data.togetherIndex].analyze
    } else {
      ana = state.condition['item_' + data.panelName].analyze
    }
    ana.freeword = data.freeword
    ana.freeword_code = data.data
    ana.mode = 'freeword'
  },
  clearCartItem (state, data) {
    if (data.panelName === 'together') {
      state.condition.item_together.conditions[data.togetherIndex].code = []
      state.condition.item_together.conditions[data.togetherIndex].analyze.code_exclude = []

      state.condition.item_together.conditions[data.togetherIndex].analyze.category.noSubmit = true
      state.condition.item_together.conditions[data.togetherIndex].analyze.category_group.noSubmit = true
      state.condition.item_together.conditions[data.togetherIndex].analyze.product_attribute.noSubmit = true

      state.submit.together[data.togetherIndex] = false
      state.submit.together.splice()
    } else {
      state.condition['item_' + data.panelName + '_code'] = []
      state.condition['item_' + data.panelName].analyze.code_exclude = []

      state.condition['item_' + data.panelName].analyze.category.noSubmit = true
      state.condition['item_' + data.panelName].analyze.category_group.noSubmit = true
      state.condition['item_' + data.panelName].analyze.product_attribute.noSubmit = true

      if (data.panelName === 'target') {
        state.condition.has_target = 0
      }
      state.submit[data.panelName] = false
    }
  },
  setCartItem (state, data) {
    if (data.panelName === 'together') {
      state.condition.item_together.conditions[data.togetherIndex].code = data.data
      if (!data.codeExclude) {
        state.condition.item_together.conditions[data.togetherIndex].analyze.code_exclude = []
      }
    } else {
      state.condition['item_' + data.panelName + '_code'] = data.data
      if (!data.codeExclude) {
        state.condition['item_' + data.panelName].analyze.code_exclude = []
      }

      if (data.panelName === 'target') {
        state.condition.has_target = 1
      }
    }
  },
  setCartItemNoList (state, data) {
    if (data.panelName === 'together') {
      state.condition.item_together.conditions[data.togetherIndex].code = []
      state.condition.item_together.conditions[data.togetherIndex].analyze.code_exclude = []
    } else {
      state.condition['item_' + data.panelName + '_code'] = []
      state.condition['item_' + data.panelName].analyze.code_exclude = []
      if (data.panelName === 'target') {
        state.condition.has_target = 1
      }
    }
  },
  clearCartItemExclude (state, data) {
    state.condition.item_base.analyze.code_exclude = data
  },
  toggleCartItemExclude (state, data) {
    let items = []
    if (data.panelName === 'together') {
      items = state.condition.item_together.conditions[data.togetherIndex].analyze.code_exclude
    } else {
      items = state.condition['item_' + data.panelName].analyze.code_exclude
    }
    const find = items.some((val, index) => {
      if (val === data.key) {
        items.splice(index, 1)
        return true
      }
      return false
    })
    if (!find) {
      items.push(data.key)
    }
  },
  addTogether (state, data) {
    state.condition.item_together.conditions.push(data)
    state.submit.together.push(false)
  },
  setCartAreaCode (state, data) {
    if (data.panelName === 'together') {
      state.condition.item_together.conditions[data.togetherIndex].analyze.product_area_code = data.areaCode
    } else {
      state.condition['item_' + data.panelName].analyze.product_area_code = data.areaCode
    }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
